import { isInsideAppleAppStoreApp } from '../../util/billing.ts';
import { compareAppVersions, getContainingApp } from '../../util/containing_app.ts';

// The first iOS store app that lets a practice video play inside the app (GitHub issue #4058). Before it, the
// app's navigation delegate (WebView.swift decidePolicyFor in the ios-webapp repo) handed every navigation to a
// host outside singyourpart.app to Safari, a page's iframes included, so entering video mode opened YouTube's
// embed page in Safari, where without a referrer it is the "Video player configuration error" page, and the app
// itself showed nothing. From 24.0.2 only the top frame and new windows leave the app, as on Android.
export const firstIOSAppVersionWithInAppVideo = '24.0.2';

// console tag of every hit, for the removal decision: the servers' request logs carry the app version too
const appUpdateLogTag = '[practice-video-app-update]';

// Whether this page may embed a YouTube player: true everywhere but inside an iOS store app older than
// `firstIOSAppVersionWithInAppVideo`, where the embed would open Safari instead (GitHub issue #4058).
//
// TODO(remove after 2027-11-01): the iOS store app before 24.0.2 cannot show a YouTube iframe; by then every
// installed app will have updated (12 months after the deploy, which is estimated to be 2026-11-01). What goes
// with it: NetworkError.VideoNeedsAppUpdate, its placeholder and update button in practice_video_mode.tsx, the
// branch in the sequencer's createAudioPlayer, the `[practice-video-app-update]` log tag and the "update the
// app" scenario in practice_video_mode.test.tsx.
export function canShowPracticeVideoInApp(): boolean {
  if (!isInsideAppleAppStoreApp()) {
    return true;
  }
  const app = getContainingApp();
  const canShow = !!app && compareAppVersions(app.appVersion, firstIOSAppVersionWithInAppVideo) >= 0;
  if (!canShow) {
    console.log(`${appUpdateLogTag} iOS app ${app?.appVersion ?? 'before 24.0'} cannot embed a practice video`);
  }
  return canShow;
}
